import {
  Paper,
  Stack,
  Avatar,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Select,
  MenuItem,
  Radio,
  Button,
  Switch
} from "@mui/material";
import axios from "axios";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import FormDialog from "src/components/common/FormDialog";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import {alert} from "src/services/alert";

const XfqTopupDialog = ({open, onClose, onFinish, user}) => {
  const [form, setForm] = useState({
    type: "PLUS", // 充值类型
    remark: "",
    amount: "",
    password: "",
    version: '1',
    xfqUsable: true,
    xfqLocked: false,
  });

  // 当 dialog 打开时重置表单
  useEffect(() => {
    if (open) {
      setForm({
        type: "PLUS",
        remark: "",
        amount: "",
        password: "",
        version: '1',
        xfqUsable: true,
        xfqLocked: false,
      });
    }
  }, [open]);

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");
    // console.log(form)
    // return;
    axios
      .post("/user/changeXfq", {
        uid: user.uid,
        ...form,
      })
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          alert(msg, "success");
          onFinish();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("topup err: ", err);
      });
  }

  return (
    <FormDialog title="修改消费券" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <UserInfo {...user} enablePreview={false}/>
      </FormItem>

      <FormItem title="版本" required>
        <RadioGroup row name="row-radio-buttons-group" value={form.version}
                    onChange={(e) => handleIptChange("version", e.target.value)}>
          <FormControlLabel value={1} control={<Radio/>} label="1.0"/>
          <FormControlLabel value={2} control={<Radio/>} label="2.0"/>
        </RadioGroup>
      </FormItem>

      {form.version == 1 && (
        <FormItem title="是否可用">
          <Switch name="row-radio-buttons-group" value={form.xfqUsable}
                  onChange={(e) => handleIptChange("xfqUsable", e.target.checked)}/>
        </FormItem>
      )}

      <FormItem title="变化" required>
        <RadioGroup row name="row-radio-buttons-group" value={form.type}
                    onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={"PLUS"} control={<Radio/>} label="增加"/>
          <FormControlLabel value={"MINUS"} control={<Radio/>} label="减少"/>
          {/* <FormControlLabel value={'FINAL'} control={<Radio />} label="最终积分" /> */}
        </RadioGroup>
      </FormItem>
      {form.version == 2 && (
        <FormItem title="同步留存">
          <Switch name="row-radio-buttons-group" value={form.xfqLocked}
                  onChange={(e) => handleIptChange("xfqLocked", e.target.checked)}/>
        </FormItem>
      )}
      <FormItem title="充值数目" required>
        <TextField fullWidth type="number" placeholder="充值数目" autoComplete="off" id="amount" value={user.amount}
                   size="small" onChange={(e) => handleIptChange("amount", e.target.value)}/>
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password}
                   size="small" onChange={(e) => handleIptChange("password", e.target.value)}/>
      </FormItem>

      <FormItem title="备注" required>
        <TextField fullWidth multiline rows={4} placeholder="备注" autoComplete="off" id="remark" value={user.remark}
                   size="small" onChange={(e) => handleIptChange("remark", e.target.value)}/>
      </FormItem>
    </FormDialog>
  );
};

export default XfqTopupDialog;
